import { render, staticRenderFns } from "./More.vue?vue&type=template&id=6133d747&scoped=true&lang=pug&"
import script from "./More.vue?vue&type=script&lang=js&"
export * from "./More.vue?vue&type=script&lang=js&"
import style0 from "./More.styl?vue&type=style&index=0&id=6133d747&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133d747",
  null
  
)

export default component.exports